import React, { useState, useEffect  } from 'react';
import Logo from "../Img/logo.png";
import CustomNavLink from "../_Components/CustomNavLink";
import { Link } from 'react-router-dom';
import API from "../Utils/api"

const MasterTemplate = (props) => {

    const [state, setState] = useState({privateMode: false})

    const usuario = JSON.parse(localStorage.getItem("user"))

    const removeToggled = (e) => {
        window.localStorage.setItem("rotaAtual", e.target.name);
        // setTimeout(reload, 100)
    }

    const logout = () => {
        window.localStorage.removeItem('user')
        window.localStorage.removeItem("rotaAtual");
        localStorage.removeItem('authAdmin');
        window.location.href = '/'
    }

    const [expanded, setExpanded] = useState(false);
    const scrollarPage = () => {
        setExpanded(!expanded)
        if (!expanded)
            window.scrollTo(500, 0);
        else {
            window.scrollTo(0, 0);
        }
    }

    
    const isPrivateMode = async () => {
        const response = await API.get('/api/parametros/get-privateMode')

        setState({
            privateMode : response.data
        })
        console.log(response.data)
        
    }

    useEffect(()=>{
        isPrivateMode()
    },[])

    const onAuth = () =>{
        document.getElementById("auth-input").value === 'tomilson'? 
        localStorage.setItem('authAdmin', 'authorized')
        : alert("palavra chave inválida!");
        window.location.reload();
    }
    const onAuthJump = () =>{
        localStorage.setItem('authAdmin', 'unauthorized');
        window.location.reload();
    }

    return (
        !localStorage.getItem('authAdmin')? 
        <div className='authenticador-container'>
            <div className='authenticador-form'>
                <div className='inputs'>
                    <input id="auth-input" type="password" placeholder='insira a palavra chave'></input>
                    <button onClick={onAuth}>authenticar</button>
                </div>
                <div className='auth-jump'>
                    <span onClick={onAuthJump} >pular authenticador</span>
                </div>
            </div>
        </div> :
        <div className="wrapper">

            <div className="sidebar">
                <div className="sidebar-wrapper">
                    <div className="logo">
                        <img src={Logo} style={{ width: '10em', height: '4em' }} />
                        <div className="text-center small mt-2">
                            <div style={{ fontWeight: '500' }}>{usuario.nome.toUpperCase()} • {usuario.perfil}</div>
                        </div>
                    </div>
                    <ul className="nav">
                        <CustomNavLink onClick={logout} className="nav-link" >
                            <i class="fas fa-sign-out-alt"></i>
                            <span>SAIR</span>
                        </CustomNavLink>
                        <CustomNavLink to="/sorteio" name="sorteio" onClick={removeToggled.bind(this)} className="nav-link" >
                            <i className="far fa-star" />
                            <span>Iniciar Sorteio</span>
                        </CustomNavLink>
                        <CustomNavLink to="/master-ganhadores-geral" name="master-ganhadores-geral"  onClick={removeToggled.bind(this)} className="nav-link" >
                            <i className="nc-icon nc-satisfied" />
                            <span>Ult. ganhadores geral</span>
                        </CustomNavLink>

                        {localStorage.getItem('authAdmin') === "authorized"? <div>
                        <CustomNavLink to="/master-ganhadores" name="master-ganhadores" onClick={removeToggled.bind(this)} className={state.privateMode? "d-none" : "nav-link"} >
                            <i className="nc-icon nc-satisfied" />
                            <span>Ult. ganhadores</span>
                        </CustomNavLink>
                        <CustomNavLink to="/master-info" name="master-info" onClick={removeToggled.bind(this)} className={state.privateMode? "d-none" : "nav-link"} >
                            <i class="fa fa-line-chart" aria-hidden="true"></i>
                            <span>Info. Sistema</span>
                        </CustomNavLink>
                        <CustomNavLink to="/master-solicitacoes-saque" name="master-solicitacoes-saque" onClick={removeToggled.bind(this)} className={state.privateMode? "d-none" : "nav-link"} >
                            <i class="fa fa-money" aria-hidden="true"></i>
                            <span>Solicitações saque</span>
                        </CustomNavLink>
                        <CustomNavLink to="/master-relatorios" name="master-relatorios" onClick={removeToggled.bind(this)} className={state.privateMode? "d-none" : "nav-link"} >
                            <i class="fas fa-book-open"></i>
                            <span>Relatorios</span>
                        </CustomNavLink>
                        <CustomNavLink to="/configuracao-giro" name="configuracao-giro" onClick={removeToggled.bind(this)} className={state.privateMode? "d-none" : "nav-link"} >
                            <i class="fab fa-android"></i>
                            <span>Config. Giro</span>
                        </CustomNavLink>
                        <CustomNavLink to="/master-recebe-pedidos" name="master-recebe-pedidos" onClick={removeToggled.bind(this)} className={state.privateMode? "d-none" : "nav-link"} >
                            <i className="nc-icon nc-tag-content" />
                            <span>Receber Pedidos</span>
                        </CustomNavLink>
                        <CustomNavLink to="/master-bilhetes" name="master-bilhetes" onClick={removeToggled.bind(this)} className={state.privateMode? "d-none" : "nav-link"} >
                        <i class="fas fa-search"></i>
                            <span>Pedidos/Cartelas</span>
                        </CustomNavLink>
                        <CustomNavLink to="/master-criar-pedidos" name="master-criar-pedidos" onClick={removeToggled.bind(this)} className={state.privateMode? "d-none" : "nav-link"} >
                            <i class="fas fa-marker"></i>
                            <span>Criar Pedidos</span>
                        </CustomNavLink>
                        <CustomNavLink to="/master-caixas-por-gerentes" name="master-caixas-por-gerentes" onClick={removeToggled.bind(this)} className={state.privateMode? "d-none" : "nav-link"} >
                            <i className="nc-icon nc-money-coins" />
                            <span>Caixa gerentes</span>
                        </CustomNavLink>
                        <CustomNavLink to="/master-caixas-por-cambistas" name="master-caixas-por-cambistas" onClick={removeToggled.bind(this)} className={state.privateMode? "d-none" : "nav-link"} >
                            <i className="nc-icon nc-money-coins" />
                            <span>Caixa cambistas</span>
                        </CustomNavLink>
                        <CustomNavLink to="/master-caixa" name="master-caixa" onClick={removeToggled.bind(this)} className={state.privateMode? "d-none" : "nav-link"} >
                            <i className="nc-icon nc-money-coins" />
                            <span>Caixa da Banca</span>
                        </CustomNavLink>
                        <CustomNavLink to="/master-gerenciar-monitores" name="master-gerenciar-monitores" onClick={removeToggled.bind(this)} className={state.privateMode? "d-none" : "nav-link"} >
                            <i className="far fa-user-circle" />
                            <span>Monitores</span>
                        </CustomNavLink>
                        <CustomNavLink to="/master-gerenciar-admins" name="master-gerenciar-admins" onClick={removeToggled.bind(this)} className={state.privateMode? "d-none" : "nav-link"} >
                            <i className="far fa-user-circle" />
                            <span>Administradores</span>
                        </CustomNavLink>
                        <CustomNavLink to="/master-gerenciar-gerentes" name="master-gerenciar-gerentes" onClick={removeToggled.bind(this)} className={state.privateMode? "d-none" : "nav-link"} >
                            <i className="far fa-user-circle" />
                            <span>Gerentes</span>
                        </CustomNavLink>
                        <CustomNavLink to="/master-gerenciar-cambistas" name="master-gerenciar-cambistas" onClick={removeToggled.bind(this)} className={state.privateMode? "d-none" : "nav-link"} >
                            <i className="far fa-user-circle" />
                            <span>Cambistas</span>
                        </CustomNavLink>
                        <CustomNavLink to="/master-gerenciar-clientes" name="master-gerenciar-clientes" onClick={removeToggled.bind(this)} className={state.privateMode? "d-none" : "nav-link"} >
                            <i className="far fa-user-circle" />
                            <span>Clientes</span>
                        </CustomNavLink>
                        <CustomNavLink to="/gerar-lotes" name="gerar-lotes" onClick={removeToggled.bind(this)} className={state.privateMode? "d-none" : "nav-link"} >
                            <i className="nc-icon nc-app" />
                            <span>Gerar lotes</span>
                        </CustomNavLink>
                        <CustomNavLink to="/master-gerenciar-series" name="master-gerenciar-series" onClick={removeToggled.bind(this)} className={state.privateMode? "d-none" : "nav-link"} >
                            <i class="fas fa-ticket-alt"></i>
                            <span>Gerenciar Séries</span>
                        </CustomNavLink>
                        <CustomNavLink to="/extrair-cartelas-avulsas" name="extrair-cartelas-avulsas" onClick={removeToggled.bind(this)} className={state.privateMode? "d-none" : "nav-link"} >
                            <i class="fas fa-ticket-alt"></i>
                            <span>Extrair avulsas</span>
                        </CustomNavLink>
                        <CustomNavLink to="/perfil-master" name="perfil-master" onClick={removeToggled.bind(this)} className={state.privateMode? "d-none" : "nav-link"} >
                            <i className="far fa-user-circle" />
                            <span>Perfil</span>
                        </CustomNavLink>
                        <CustomNavLink to="/configuracoes" name="configuracoes" onClick={removeToggled.bind(this)} className="nav-link">
                            <i className="nc-icon nc-settings-gear-64" />
                            <span>Configurações</span>
                        </CustomNavLink>
                        </div>
                        : ""}
                    </ul>
                </div>
            </div>
            <div className="main-panel">
                <nav className="navbar navbar-expand-lg " color-on-scroll="500">
                    <div className="container-fluid">
                        <Link className="navbar-brand" to="#">
                            {props.label}
                        </Link>
                        <button
                            id="sideButton"
                            href="#"
                            className="navbar-toggler navbar-toggler-right"
                            type="button"
                            data-toggle="collapse"
                            aria-controls="navigation-index"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                            onClick={scrollarPage}
                        >
                            <span className="navbar-toggler-bar burger-lines" />
                            <span className="navbar-toggler-bar burger-lines" />
                            <span className="navbar-toggler-bar burger-lines" />
                        </button>
                        <div
                            className="collapse navbar-collapse justify-content-end"
                            id="navigation"
                        >
                            {/* <ul className="navbar-nav ml-auto">
                                <li className="nav-item">
                                    <CustomNavLink className="nav-link" name="logout" onClick={removeToggled.bind(this)}>
                                        <span className="no-icon">Sair</span>
                                    </CustomNavLink>
                                </li>
                            </ul> */}
                        </div>
                    </div>
                </nav>
                <div className="content">
                    {props.children}
                </div>
                <footer className="footer">
                    <div className="container-fluid">
                        <nav>
                            <ul className="footer-menu">
                                <li>
                                    <Link to="#">Empresa</Link>
                                </li>
                                <li>
                                    <Link to="#">Regulamento</Link>
                                </li>
                                <li>
                                    <Link to="#">Outros projetos</Link>
                                </li>
                            </ul>
                            <p className="copyright text-center">
                                Proprietário ©
                                <Link to="https://www.instagram.com/sorteflash/">SorteFlash</Link>
                            </p>
                        </nav>
                    </div>
                </footer>
            </div>
        </div>
    );
};

export default MasterTemplate;